<template>
  <a-modal title="插入页面链接" :visible="visible" @ok="handleOk" @cancel="handleCancel">
    <a-form-model :model="form" class="container-ant" ref="ruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="封面图" prop="img_url">
        <div class="flex" style="position: relative;">
          <el-upload :size="photoSize" :limit="1" v-model="form.bg_url" :showPrompt="false" @on-success="handleMainImageSuccess" @on-remove="handleMainImageSuccess" :showUploadTip="true"
            :list="form.img_url"></el-upload>
          <div class="image-tips">
            <p class="tips-p">大小不超过50M；</p>
            <p class="tips-p">建议使用png格式以保持最佳效果；</p>
            <p class="tips-p">建议图片尺寸宽为750px；</p>
          </div>
        </div>
      </a-form-model-item>
      <a-form-model-item label="跳转链接" prop="path">
        <a-input v-model="form.path" style="width:300px" placeholder="请输入小程序页面链接" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
 
<script>
// import AntUpload from "@/components/AntUpload"
export default {
  // components: { AntUpload },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    }
  },
  watch: {
    visible() {
      if (this.visible) {
        this.$nextTick(() => {
          this.$refs.ruleForm.resetFields()
        })
      }
    }
  },
  methods: {
    handleOk() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          this.$emit('ok', this.form)
        }
      })
    },
    handleCancel() {
      this.$emit('cancel')
    },
    handleMainImageSuccess(arr) {
      this.form.img_url = arr
    }
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      photoSize: {
        width: '100px',
        height: '100px'
      },
      form: {
        img_url: [],
        path: ''
      },
      rules: {
        img_url: [{ required: true, message: '请上传封面', trigger: ['focus'] }],
        path: [{ required: true, message: '请输入链接', trigger: ['blur', 'change'] }]
      }
    }
  }
}
</script>

<style lang="less" scoped>
.image-tips {
  position: absolute;
  right: -2px;
  top: 0;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
  line-height: initial;
}
/deep/.imgupload .updata__operation {
  margin: 0 20px 0px 0;
}
</style>
